import {initWebComponent} from "@/helpers/web-component-helper";
import {addLayer, getLayerByName} from "@/helpers/ol/ol-layer-helper";
import {toggleGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import {loadInfoItemGeometryMeasure} from "@/helpers/layer/info/layer-info-info-item-geometry-measure-helper";
import {getFeatureByIndex} from "@/helpers/main-tab-helper";
import {showNotification} from "@/helpers/notification-helper";
import {hideLayerInfoForm} from "@/helpers/layer/info/layer-info-helper";

export class LayerInfoInfoItemGeometryMeasureButton extends HTMLElement {
    constructor(){
        super();

        const mainTabIndex = this.getAttribute('data-main-tab-index')
        const featureIndex = this.getAttribute('data-feature-index')
        const formID = this.getAttribute('data-form-id')
        const featureInfoIndex = this.getAttribute('data-feature-info-index')
        const formName = this.getAttribute('data-form-name')

        const template = document.createElement('template');

        template.innerHTML = `<button class="btn btn-sm btn-outline-secondary icon-btn text-transform-none popper-header" href="#">
                          <span class="fa fa-ruler"></span>
                          <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                             Meet object
                            <div class="arrow" data-popper-arrow=""</div>
                          </div>
                    </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {

            const feature = getFeatureByIndex(mainTabIndex, featureIndex, featureInfoIndex)
            const result = loadInfoItemGeometryMeasure(feature, formID, mainTabIndex, formName)

            if(result) {
                document.querySelector('layer-info-info').classList.add('d-none')
                document.querySelector('layer-info-info-geometry-measure').classList.remove('d-none')
            } else {
                showNotification('Meten van cirkel is nog niet mogelijk', '', 'warning')
                hideLayerInfoForm(true)
            }
        })
    }
}

